import { render, staticRenderFns } from "./ElemMenuItem.vue?vue&type=template&id=245c3251&"
import script from "./ElemMenuItem.vue?vue&type=script&lang=js&"
export * from "./ElemMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports